import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

import { getCachedInvoiceImageBlob } from '../utils/invoice-image-cache';

// currentInvoice refer to the dashboard
const InvoicePreview = ({ file_name, currentInvoice, showPreviewOnClick = true, data }) => {
  const cancelSourceRef = useRef(null);
  const objectUrlRef = useRef(null);

  const [pdf, setPdf] = useState('');
  const [pdfError, setPdfError] = useState(false);
  const [hide, setHide] = useState(false);
  useEffect(() => {
    if (!cancelSourceRef.current) {
      cancelSourceRef.current = axios.CancelToken.source();
    }
    setPdfError(false);

    // currentInvoice === null means that no invoice selected, the modal is closed
    if (currentInvoice === null && pdf === '' && file_name) {
      let active = true;
      // XPEN-326: cached Blob -> per-mount object URL, revoked on unmount.
      getCachedInvoiceImageBlob(file_name, cancelSourceRef.current.token)
        .then((blob) => {
          if (!active) return;
          const objectUrl = URL.createObjectURL(blob);
          objectUrlRef.current = objectUrl;
          setPdf(objectUrl);
        })
        .catch(() => {
          if (active) setPdfError(true);
        });
      return () => {
        active = false;
      };
    }
  }, [file_name, currentInvoice]);

  useEffect(
    () => () => {
      cancelSourceRef.current?.cancel('preview invoice unmounted');
      if (objectUrlRef.current) {
        window.URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    },
    []
  );

  if (pdfError) {
    return (
      <div className="text-muted small p-2" title={data?.t?.read('invoice.pdf_not_available')}>
        {data?.t?.read('invoice.pdf_not_available') ?? 'PDF not available'}
      </div>
    );
  }
  return pdf !== '' && pdf !== null ? (
    <div>
      <div
        className='preview-plus'
        onClick={(e) => {
          setHide(!hide);
          e.stopPropagation();
        }}
      ></div>
      <object data={pdf} className='preview' alt='invoice' aria-label='invoice' />
      {showPreviewOnClick && hide && (
        <div className='fadeIn animate modal d-block' onClick={() => setHide(!hide)}>
          <div
            id='invoice-preview-modal'
            onClick={(e) => e.stopPropagation()}
            className='modal-dialog'
            role='document'
            style={{ maxWidth: '50%', height: '70vh' }}
          >
            <div className='modal-content' style={{ width: '100%', height: '100%' }}>
              <div className='modal-body'>
                <div id='icon-preview-close' className='pointer' onClick={() => setHide(false)}>
                  <div>
                    <FontAwesomeIcon icon={faWindowClose} />
                  </div>
                </div>
                <object width='100%' height='100%' type='application/pdf' data={pdf} aria-label='PDF'></object>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div>
      <div className='card' id='card-link'>
        <div className='card__header'>
          <div>
            <img className='card__header header__img skeleton' id='logo-img' alt='' />
          </div>
          <h3 className='card__header header__title' id='card-title'>
            <div className='skeleton skeleton-text'></div>
            <div className='skeleton skeleton-text'></div>
          </h3>
        </div>

        <div className='card__body'>
          <div className='card__body body__text' id='card-details'>
            <div className='skeleton skeleton-text skeleton-text__body'></div>
          </div>

          <div className='card__body body__img'>
            <img className='skeleton' alt='' id='cover-img' />
          </div>
        </div>

        <div className='card__footer' id='card-footer'>
          <div className='skeleton skeleton-text skeleton-footer'></div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
